const RESIZE_OBSERVER_LOOP_RE =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;

/**
 * Some browsers (notably Chromium) can emit a benign `ResizeObserver` loop warning as a window
 * `error` event. In CRA dev this can incorrectly surface as a red runtime error overlay.
 *
 * We suppress ONLY this specific message so real runtime errors still propagate normally.
 */
export function initResizeObserverLoopErrorSuppression() {
  if (typeof window === "undefined") return;

  // Persist across Fast Refresh / HMR.
  if (window.__VITAE_RESIZE_OBSERVER_LOOP_SUPPRESSION__) return;
  window.__VITAE_RESIZE_OBSERVER_LOOP_SUPPRESSION__ = true;

  window.addEventListener(
    "error",
    (evt) => {
      try {
        const msg = evt?.message || evt?.error?.message || "";
        if (!RESIZE_OBSERVER_LOOP_RE.test(String(msg))) return;

        // Prevent error overlays / error monitors from treating this as a fatal exception.
        evt.preventDefault?.();
        evt.stopImmediatePropagation?.();
      } catch (_) {
        // never throw from global handler
      }
    },
    true, // capture: run before bubble listeners (e.g. error overlays)
  );
}

